<template>
  <div class="result-page">
    <v-header :need-back="false">{{title}}</v-header>
    <div class="error-tips" v-if="isError">
      <i class="icon-warning"></i>溫馨提示：請截圖錯誤信息，便於聯繫客服查詢失敗原因
    </div>
    <div
      class="result-content"
      :class="[!isError ? 'success' : false, hasCoupon? 'has-coupon' : false]"
    >
      <div class="result-content_tips">
        <i class="result-icon" :class="isError ? 'error' : 'success'"></i>
        <div class="result-text">
          <template v-if="!isError">
            <!-- <div class="store-text">成功兌換{{storeValue}}G幣</div>
            <div v-if="couponValue" class="coupon-text">並獲贈{{couponValue}}G幣抵用券</div>-->
            <div class="purchase-title">購買成功</div>
            <div class="pre-text">
              購買成功後通常會在5min內到帳
              <span class="hide-text">
                <br />請稍後於遊戲內查看
              </span>
            </div>
          </template>
          <template v-else-if="isStore&&isError">
            <div class="error-text">本次兌換G幣失敗</div>
          </template>
          <!-- <template v-else-if="!isStore&&!isError">
            <div class="purchase-title">購買成功</div>
            <div class="pre-text">
              購買成功後通常會在15min內到帳
              <br />請稍後於遊戲內查看
            </div>
          </template>-->
          <template v-else-if="!isStore&&isError">
            <div class="purchase-title">購買失敗</div>
            <div class="pre-text">
              非常抱歉本次購買失敗
              <span class="portrait-break">，</span>
              <span class="landscape-break">
                <br />
              </span>
              請您重新嘗試
              <span class="portrait-break">
                <br />
              </span>
              購買或聯繫客服解決
            </div>
          </template>
        </div>
        <div class="result-content_button">
          <div class="button-group">
            <pl-gradient-button
              class="pl-button"
              :key="item.label"
              @click="item.event"
              v-for="item in buttonList"
              :type="item.btnType === 'spec' ? 'default' : 'plain'"
            >{{item.label}}</pl-gradient-button>
          </div>
        </div>
      </div>
      <div class="result-content_main">
        <div class="result-detail">
          <div
            class="detail-item"
            v-for="item in detailList"
            :key="item.prop"
            :class="item.type === 'extract' ? 'extract' : false"
          >
            <span class="detail-item_label">{{item.label}}</span>
            <span class="detail-item_value">{{item.value}}</span>
          </div>
          <template v-if="hasExtract">
            <!-- <div v-if="isStore" class="extract-text detail-coupon">可用抵用券：{{couponNumber}}張</div> -->
            <div v-if="!isStore" class="extract-text detail-price">商品原價{{price}}G幣</div>
            <div
              v-if="!isStore&&couponPrice"
              class="extract-text detail-coupon"
            >抵用券-{{couponPrice}}G幣</div>
          </template>
        </div>
        <div class="error-msg" :class="isError ? 'has-text' : false">
          <template v-if="isError">錯誤信息：{{errorMsg}}</template>
        </div>
      </div>
      <div class="result-content_button">
        <div class="button-group">
          <pl-gradient-button
            :key="item.label"
            @click="item.event"
            :class="item.classList"
            v-for="item in buttonList"
            :type="item.btnType === 'spec' ? 'default' : 'plain'"
          >{{item.label}}</pl-gradient-button>
        </div>
      </div>
      <div class="result-content_credit">
        <p class="result-content_credit_desc">如您在剛才的支付頁面中選擇了存儲卡號，我們會收集您的信用卡數據已加密形式進行存儲（**** **** **** 1234）。</p>
        <p class="result-content_credit_desc">我們存儲加密的信息只是為了方便您的儲值體驗，您不必在下次購買時輸入卡號。</p>
        <a class="result-content_credit_desc more" href="javascript:void(0);" @click="showCredentialsDialog = true">了解更多細節 》</a>
      </div>
    </div>
    <div class="result-content_coupon" v-if="hasCoupon">
      <p class="result-content_coupon--title">恭喜您獲得抵扣券，盡情享受專屬優惠吧~</p>
      <div class="result-content_coupon--content">
        <div class="result-content_coupon--left">
          <p class="result-content_coupon--left-value">
            <span class="spec-value">{{curCoupon.REDUCTION}}</span>
            <span class="spec-currency">G幣</span>
          </p>
          <p class="result-content_coupon--left-base">{{curCoupon.limitText}}</p>
        </div>
        <div class="result-content_coupon--right">
          <p class="result-content_coupon--right-name">
            <span class="spec-name">{{curCoupon.couponType}}</span>
            {{curCoupon.couponDesc}}
          </p>
          <span class="result-content_coupon--right-use" @click="useCoupon(curCoupon)">使用</span>
        </div>
        <div class="result-content_coupon--line"></div>
        <div class="result-content_coupon--time">{{curCoupon.timeText}}</div>
        <span class="result-content_coupon--tips">
          <i class="result-content_coupon--icon"></i>不可疊加使用
        </span>
      </div>
    </div>
    <pl-tips 
      v-if="showCredentialsDialog" 
      :title="title" 
      :mainStyle="'overflow: auto; display: block;'"
      @close="showCredentialsDialog=false" 
      class="big">
      <template #body>
        <div class="result_dialog_credit">
            <p class="result_dialog_credit_desc">為了更好地保護客戶數據安全，Visa和Mastercard引入了新的“存儲憑據”技術，並規範化了存儲憑據和相關交易</p>
            <p class="result_dialog_credit_desc">當您在我們的網站上購物時，我們會以加密版本收集您的信用卡數據（**** **** **** 1234）。我們將保留此加密數據4年，如有任何相關變更，我們將在我們的網站上更新用戶條款與隱私政策。我們存儲加密信用卡數據只是為了優化您的支付體驗，您不必在下次購買時輸入卡號。</p>
            <div class="result_dialog_credit_confirm" @click.stop="showCredentialsDialog=false">確認</div>
        </div>
      </template>
  </pl-tips>
  </div>
</template>

<script>
import vHeader from '@/components/header'
import plGradientButton from '@/components/pl-gradient-btn'
import plTips from '@/components/pl-tips'
import {
  base64,
  convertObjToString,
  convertStringToParam,
  getHrefParamFromLocation as getHrefParam
} from '@/utils'

export default {
  name: 'ResultPage',
  components: { vHeader, plGradientButton, plTips },
  data () {
    return {
      title: '儲值結果',
      isStore: true,
      storeValue: 0,
      couponValue: 0,
      wallet: 0,
      detailTemplate: {
        store: [
          { label: '訂單號', prop: 'order_id' },
          { label: '儲值賬號', prop: 'account' },
          { label: '購買商品', prop: 'productName' },
          { label: '購買時間', prop: 'time' },
          { label: '支付價格', prop: 'payMoney' }
          // {
          //   type: 'extract',
          //   label: '賬戶餘額',
          //   prop: 'unused',
          //   template: '{{unused}}G幣'
          // }
        ],
        purchase: [
          { label: '訂單號', prop: 'ano' },
          { label: '遊戲', prop: 'game' },
          {
            label: '角色',
            prop: 'serverName',
            template: '{{serverName}}, {{roleName}}'
          },
          { label: '購買商品', prop: 'product' },
          {
            type: 'extract',
            label: '支付金額',
            prop: 'price',
            template: '{{price}}G幣'
          }
        ]
      },
      // couponNumber: 0,
      price: 0,
      couponPrice: 0,
      detailList: [],
      hasExtract: false,
      isError: false,
      errorMsg: '',
      buttonList: [],
      buttonTemplate: {
        store: [
          {
            label: '兌換道具',
            event: 'exchangeProp',
            type: 'success',
            btnType: 'spec',
            classList: 'j-exchange-product-dcount'
          },
          {
            label: '我的錢包',
            event: 'myWallet',
            type: 'success',
            btnType: 'normal',
            classList: 'j-mywallet-dcount'
          },
          {
            label: '重新購買',
            event: 'restore',
            type: 'fail',
            btnType: 'spec',
            classList: 'j-repurchase-dcount'
          },
          {
            label: '聯繫客服',
            event: 'connectGM',
            type: 'fail',
            btnType: 'normal',
            classList: 'j-contact-gm-dcount'
          }
        ],
        purchase: [
          {
            label: '返回',
            type: 'success',
            event: 'back',
            btnType: 'normal',
            classList: 'j-back-btn-dount'
          },
          {
            label: '重新購買',
            type: 'fail',
            event: 'repurchase',
            btnType: 'spec',
            classList: 'j-repurchase-dcount'
          },
          {
            label: '聯繫客服',
            type: 'fail',
            event: 'connectGM',
            btnType: 'normal',
            classList: 'j-contact-gm-dcount'
          }
        ]
      },
      fromSDK: false,
      storeParams: {},
      hasCoupon: false,
      curCoupon: {},
      showCredentialsDialog: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.getUserInfo
    }
  },
  methods: {
    myWallet () {
      this.$datain({ ext3: '跳轉我的錢包' })
      // this.$router.push({ name: 'wallet' })
      let obj = {
        gameId: this.storeParams.gameId || '',
        gameName: this.storeParams.gameName || '',
        serverId: this.storeParams.serverId || '',
        serverName: this.storeParams.serverName || '',
        roleId: this.storeParams.roleId || '',
        roleName: this.storeParams.roleName || '',
        roleLevel: this.storeParams.roleLevel || '',
        cid: this.storeParams.cid || '',
        scid: this.storeParams.scid || '',
      }
      window.location.href = `//mstore.gm99.com/points/${convertObjToString(obj)}#/wallet`
    },
    useCoupon (coupon) {
      this.$datain({ ext3: '赠送抵扣券-使用按钮', ext15: coupon.COUPON_ID })
      window.location.href = `//mstore.gm99.com?cid=${this.storeParams.cid || ''}&scid=${this.storeParams.scid || ''}`;
    },
    exchangeProp () {
      this.$datain({ ext3: '兌換道具' })
      if (this.storeParams.fromUrl) {
        window.location.href = this.storeParams.fromUrl
      } else {
        if (this.fromSDK) {
          let search = window.sessionStorage.getItem('search')
          window.location.href =
            process.env.NODE_ENV === 'development'
              ? `//zero.gm99.com:8080/channel.html${search}`
              : `//mstore.gm99.com/points/pay/${search}`
        } else {
          let query = this.storeParams.gameId
            ? {
              gameId: this.storeParams.gameId,
              serverId: this.storeParams.serverId,
              roleId: this.storeParams.roleId
            }
            : {}
          this.$router.push({ name: 'game', query })
        }
      }
    },
    restore () {
      this.$datain({ ext3: '再儲一筆' })
      if (this.storeParams.restoreUrl) {
        window.location.href = decodeURIComponent(this.storeParams.restoreUrl)
      } else {
        window.location.href =
          process.env.NODE_ENV === 'development'
            ? `//zero.gm99.com:8080/#/store?reStore=1`
            : `//mstore.gm99.com/points/?cid=${this.storeParams.scid || ''}&scid=${this.storeParams.scid || ''}#/store?reStore=1`
        // this.$router.push({ name: 'store', query: { reStore: 1 } })
      }
    },
    connectGM () {
      this.$datain({ ext3: `儲值${this.isError ? '失敗' : '成功'}-聯繫客服` })
      if (this.fromSDK) {
        this.useSDKMethod('openFaqInBrowser')
      } else {
        let getDevice = () => {
          let ua = navigator.userAgent
          let isWindowsPhone = /(?:Windows Phone)/.test(ua)
          let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
          let isAndroid = /(?:Android)/.test(ua)
          let isFireFox = /(?:Firefox)/.test(ua)
          let isChrome = /(?:Chrome|CriOS)/.test(ua)
          let isTablet =
            /(?:iPad|PlayBook)/.test(ua) ||
            (isAndroid && !/(?:Mobile)/.test(ua)) ||
            (isFireFox && /(?:Tablet)/.test(ua))
          let isPhone = /(?:iPhone)/.test(ua) && !isTablet
          let isPc = !isPhone && !isAndroid && !isSymbian
          return {
            isTablet,
            isPhone,
            isAndroid,
            isPc,
            isChrome
          }
        }
        let os = getDevice()
        if (os.isPc) {
          window.location.href = 'https://msupport.gm99.com/#submit'
        } else {
          window.location.href = `//service.gm99.com/#/wo?gameId=${this.userInfo.game_id}&serverId=${this.userInfo.server_id}&roleId=${this.userInfo.role_id}`
        }
      }
    },
    useSDKMethod (method) {
      if (window[method]) {
        window[method]()
      } else if (window.sdkCtrl && window.sdkCtrl[method]) {
        window.sdkCtrl[method]()
      }
    },
    repurchase () {
      this.$datain({ ext3: '儲值失敗-重新購買' })
      if (this.fromSDK) {
        let search = window.sessionStorage.getItem('search')
        window.location.href =
          process.env.NODE_ENV === 'development'
            ? `//zero.gm99.com:8080/channel.html${search}`
            : `//mstore.gm99.com/points/pay/${search}`
      } else {
        let query = JSON.parse(window.sessionStorage.getItem('order-params'))
        this.$router.push({ name: 'order', query })
      }
    },
    back () {
      if (this.fromSDK) {
        this.useSDKMethod('closeWebview')
      } else {
        this.$router.push({ name: 'game' })
      }
    },
    async fetchUserData () {
      return this.$jsonp('//mstore.gm99.com/points/user_data')
        .then((res) => {
          let data = res.data
          if (+res.result >= 1) {
            // this.couponNumber = data.coupons.length
            this.wallet = data.user_info.POINTS
          } else {
            // this.couponNumber = 0
            this.$store.commit('setTipsState', true)
            this.$store.commit('setTipsContent', '獲取數據失敗')
          }
        })
        .catch((err) => {
          this.$store.commit('setTipsState', true)
          this.$store.commit('setTipsContent', err.message || '系統錯誤')
        })
    },
    initCoupon (coupon) {
      function formatTimeText (str) {
        if (str.startsWith('9999')) {
          return '無限期'
        }
        let index = str.indexOf(' ')
        return str.substr(0, index).replace(/-/gi, '.')
      }
      let game = !+coupon.GAME_ID ? '' : coupon.GAME_NAME
      let extraText
      switch (coupon.LIMIT_FACTOR) {
        case '':
          extraText = '全品類商品'
          break
        case 'package':
          extraText = '禮包類商品'
          break
        case 'coin':
          extraText = '遊戲幣類商品'
          break
        default:
          extraText = coupon.PRODUCT_DESC
          break
      }
      coupon.couponType = `【${
        !coupon.LIMIT_FACTOR ? '通用券' : '限定券'
      }】`
      coupon.couponDesc = `可用於購買[${game || '所有遊戲'}]的${extraText || ''}`
      coupon.limitBottom = +coupon.LIMIT_BOTTOM
      coupon.limitText = coupon.limitBottom
        ? `滿${coupon.limitBottom}G幣可用`
        : '無門檻'
      coupon.timeText = `${formatTimeText(
        coupon.START_TIME
      )}-${formatTimeText(coupon.EXPIRY_TIME)}`
      return coupon
    },
    async fetchOrderCoupon (userId, orderId) {
      return this.$jsonp('//mstore.gm99.com/points/show_order_coupon', {
        user_id: userId,
        order_id: orderId
      })
        .then((res) => {
          let data = res.data
          this.hasCoupon = false
          if (+res.result >= 1 && data.coupons.length >= 1) {
            this.hasCoupon = true
            this.$datain({ ext3: '存在赠送抵扣券', event: 'load' })
            this.curCoupon = this.initCoupon(data.coupons[0])
          }
        })
        .catch((err) => {
          this.hasCoupon = false
          this.$store.commit('setTipsState', true)
          this.$store.commit('setTipsContent', err.message || '系統錯誤')
        })
    }
  },
  async created () {
    let btnType = 'success'
    let query = this.$route.query
    let params = convertStringToParam(window.location.search)
    let isPurchase = getHrefParam('purchase')
    let storeObj = JSON.parse(window.localStorage.getItem('storeObj') || '{}')
    this.isStore = !isPurchase
    this.errorMsg = getHrefParam('msg')
    this.isError = +getHrefParam('result') === 0
    this.title = this.isStore ? '儲值結果' : '訂單信息'
    let type = this.isStore ? 'store' : 'purchase'
    let list = this.detailTemplate[type]
    let storeParams
    if (window.atob) {
      storeParams = atob(decodeURIComponent(params.store_url_params || ''))
    } else {
      storeParams = base64.decode(
        decodeURIComponent(params.store_url_params || '')
      )
    }
    if (storeParams) {
      storeParams = JSON.parse(storeParams)
      this.storeParams = storeParams
      this.storeValue = storeParams.unused
      this.couponValue = storeParams.couponValue
      await this.fetchUserData()
      await this.fetchOrderCoupon(params.user_id, params.order_id)
    }
    this.$datain({
      gameID: storeParams ? storeParams.gameId || 0 : 0,
      ext3: this.isError ? '儲值失敗' : '儲值成功',
      ext13: this.isError ? this.errorMsg : '成功',
      ...storeObj
    })
    let mockData = this.isStore
      ? {
        order_id: params.order_id,
        ...storeParams,
        unused: this.wallet
      }
      : query
    if (this.isError) {
      if (this.isStore) {
        mockData.unused = 0
      } else {
        mockData.price = 0
        mockData.oldPrice = 0
        mockData.couponPrice = 0
      }
      btnType = 'fail'
    }
    this.detailList = list.reduce((arr, item) => {
      if (mockData[item.prop]) {
        item.value = item.template
          ? item.template.replace(/{{(.*?)}}/gi, (...args) => mockData[args[1]])
          : mockData[item.prop]
        arr.push(item)
      }
      return arr
    }, [])
    this.hasExtract =
      this.detailList.findIndex((item) => item.type === 'extract') > -1
    this.buttonList = this.buttonTemplate[type].reduce((arr, item) => {
      if (item.type === btnType) {
        item.event = this[item.event]
        arr.push(item)
      }
      return arr
    }, [])
    if (!this.isStore) {
      this.price = mockData.oldPrice
      this.couponPrice = mockData.couponPrice
    }
    this.fromSDK = +window.sessionStorage.getItem('fromSDK') === 1
    this.$store.commit('setLoadingState', false)
    try {
      var res = getHrefParam('result')
      var message = parseInt(res) === 0 ? this.errorMsg : '支付成功'
      window.sdkBehave.behaveLinkFinish(res, message, 0)
    } catch (e) {}
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/result.scss";
</style>
